import { ReactNode } from "react";
import { ChakraProvider, ColorModeProvider } from "@chakra-ui/react";

import theme from "../theme";
import { FileUploadProvider, useFileUpload } from "./FileUpload";
import { AuthProvider, useAuth } from "./Authentication";
import { AppConfigProvider, useModels } from "./AppConfig";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export {
  useFileUpload,
  useModels,
  useAuth
};

const queryClient = new QueryClient();

type Props = {
  children: ReactNode;
}

export default function ContextProviders({ children }: Props) {
  return (
    <ColorModeProvider>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AppConfigProvider>
              <FileUploadProvider>
                { children }
              </FileUploadProvider>
            </AppConfigProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ChakraProvider>
    </ColorModeProvider>
  );
}
